export const baseUrl = 'https://engine.hotellook.com/api/v2/cache.json'